module.exports = __webpack_public_path__ + "img/wx-qr.7f2448fd.png";